import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { nakshatramService } from './nakshatram.service';

export const useGetAllNakshatrams = (page = 1, limit = 10) => {
  return useQuery({
    queryKey: ['nakshatramService.getAll', page, limit],
    queryFn: () => nakshatramService.getAll(page, limit),
  });
};

export const useGetNakshatramById = (nakshatramId) => {
  return useQuery({
    queryKey: ['nakshatramService.getById', nakshatramId],
    queryFn: () => nakshatramService.getById(nakshatramId),
  });
};

export const useCreateNakshatram = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ name, description }) =>
      nakshatramService.createNakshatram(name, description),
    onSuccess: () => {
      queryClient.invalidateQueries('nakshatramService.getAll');
    },
  });
};

export const useUpdateNakshatram = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ nakshatramId, name, description }) =>
      nakshatramService.updateNakshatram(nakshatramId, name, description),
    onSuccess: () => {
      queryClient.invalidateQueries('nakshatramService.getAll');
    },
  });
};

export const useDeleteNakshatram = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ nakshatramId }) =>
      nakshatramService.deleteNakshatram(nakshatramId),
    onSuccess: () => {
      queryClient.invalidateQueries('nakshatramService.getAll');
    },
  });
};
